import React from "react";
import Accordion from "~/components/utils/Accordion";
import { useTranslation } from "react-i18next";
import LayoutSettings from "~/components/settings/LayoutSettings";

const LayoutSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Accordion
      items={[
        {
          title: t("layoutSettings"),
          content: <LayoutSettings />,
          dynamicHeight: true,
        },
      ]}
    />
  );
};

export default LayoutSection;
